import { requestApi, parseResponse } from '~/services/api.js';

const host = '/';

export const sendClientIdForTrackingCall = googleClientId => {
	return requestApi(`${host}tracking/client-id`, googleClientId, 'POST');
};

export const setTermsAndConditionsCall = payload => {
	return requestApi(`${host}complianceterms/update/termsandconditions`, payload, 'POST');
};

export const setPrivacyPolicyCall = payload => {
	return requestApi(`${host}complianceterms/update/privacypolicy`, payload, 'POST');
};
export const getLocaleInfoCall = () => {
	return requestApi(`${host}registerbox`);
};

// Auth
const AUTH_BASE_URL = '/auth';

export const preloginCall = email => {
	return requestApi(`${AUTH_BASE_URL}/preLogin`, { email }, 'POST');
};

export const loginCall = payload => {
	const { nonce, ...rest } = payload;
	return requestApi(`${AUTH_BASE_URL}/${nonce ? 'nonceLogin' : 'login'}`, nonce ? { nonce } : rest, 'POST');
};

export const logoutCall = () => {
	return requestApi(`${AUTH_BASE_URL}/logout`);
};

// Rest
const REST_BASE_URL = '/rest/register';

export const checkRegisterFieldUniqueCall = ({ field, values, guestFranchiseId }) => {
	return requestApi(
		`${REST_BASE_URL}/${field.toString().toLowerCase()}/${values.join('/')}`,
		{},
		'GET',
		false,
		false,
		guestFranchiseId ? { guestFranchiseId } : {},
		{},
		true
	);
};

export const getTokenCall = async payload => {
	return parseResponse(await requestApi(`${REST_BASE_URL}/token`, payload, 'POST'));
};

export const registerCall = (payload, xSellReferrer = null) => {
	// rest/register/player
	return requestApi(`${REST_BASE_URL}/player/`, payload, 'PUT', false, false, {
		...(xSellReferrer ? { 'Comeon-X-Sell-Referrer': xSellReferrer } : {})
	});
};

export const registrationPhoneVerificationCall = ({ phoneNumber, code }) => {
	return requestApi(`${REST_BASE_URL}/sms/validate`, { phoneNumber, smsCode: code }, 'POST');
};

export const registrationSMSResendCall = ({ phoneNumber }) => {
	return requestApi(`${REST_BASE_URL}/sms/resend`, { phoneNumber }, 'POST');
};

// Player
const PLAYER_BASE_URL = '/player';

export const updateMissingDataCall = payload => {
	return requestApi(`${PLAYER_BASE_URL}/extraDetailsAndTerms`, payload, 'POST');
};

export const sendExtraDetailsCall = ({ playerIdString, nationalityCountryCode, familyName, birthplace }) => {
	return requestApi(
		`${PLAYER_BASE_URL}/extraDetails`,
		{
			playerIdString,
			nationalityCountryCode,
			familyName,
			birthplace
		},
		'POST'
	);
};

export const senStateCodeCall = ({ encryptedPlayerId, stateCode }) => {
	return requestApi(`${PLAYER_BASE_URL}/state`, { encryptedPlayerId, stateCode }, 'POST');
};

export const loginLugasCall = ({ encryptedPlayerId, lugasDepositLimit }) => {
	return requestApi(`${PLAYER_BASE_URL}/lugas/login`, { encryptedPlayerId, lugasDepositLimit }, 'POST');
};
